import React from 'react';
import { connect } from 'react-redux';
import { IMAGES } from 'src/appConfig/images';
import { DepositionStatus, FileData, FileType } from 'src/dataFactory/depositionFactory';
import { IAppState } from 'src/store';
import { Image, Text, View } from '../common';
import DepositionFileItem from '../DepositionFileItem';
import './styles.scss';

const DepositionSwichtableListView: React.FC<Props> = ({
  isGrid = true,
  fileType = 'exhibit',
  status = 'pending',
  isLocked = false,
  isMultiSelect = false,
  files = [],
  onSelectFile,
  onDeleteFile,
  onRenameFile,
  onDownloadFile,
  ...props
}) => {
  return files.length === 0 ? (
    <View align="center" className="mt-48 mb-72">
      <Image src={IMAGES.iconFolderEmpty} className="cmp-deposition-files__empty" />
      <Text>This folder is empty now!</Text>
    </View>
  ) : (
    <div className="columns is-multiline is-mobile is-1-mobile is-4-desktop ">
      {files.map((e, index) => (
        <div className={`column ${isGrid ? 'is-narrow' : 'is-full'}`}>
          <DepositionFileItem
            key={`deposition-item-${index}`}
            index={index}
            isGrid={isGrid}
            isMulti={isMultiSelect}
            data={e}
            status={status}
            fileType={fileType}
            onSelect={onSelectFile}
            onDelete={onDeleteFile}
            onRename={onRenameFile}
            onDownload={onDownloadFile}
          />
        </div>
      ))}
    </div>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    isGrid?: boolean;
    files?: FileData[];
    isLocked?: boolean;
    isMultiSelect?: boolean;
    fileType?: FileType | undefined;
    status?: DepositionStatus;
    onSelectFile?: (...args: any[]) => void;
    onDeleteFile?: (...args: any[]) => void;
    onRenameFile?: (...args: any[]) => void;
    onDownloadFile?: (...args: any[]) => void;
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionSwichtableListView);
